export default __webpack_public_path__ + "static/media/rocket-icon.8718b673.svg";